import configurationService from '../services/configurationService';

export const GET_CONFIGURATIONS = '@types/get-dispatch-configurations';
export const GET_WORKFLOW_FILTERS = '@types/get-workflow-filters';

export function getWorkflowFilters() {
  const request = configurationService.getSettings({}, 'dispatch-workflow-filters');

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_WORKFLOW_FILTERS,
      payload: response
    }));
  };
}

export function getConfigurations() {
  const request = configurationService.getConfigurations();

  return (dispatch) => {
    request.then((response) => dispatch({
      type: GET_CONFIGURATIONS,
      payload: response
    }));
  };
}
